import { Injectable } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

import { DialogService } from '@tv3/services/utils/dialog.service'
import {
  RentalRatesDialogComponent,
  RentalRatesDialogInput,
  RentalRatesDialogResult,
} from './rental-rates-dialog.component'

@Injectable()
export class RentalRatesDialogService {
  constructor(private dialogService: DialogService) {}

  public openSide(data: RentalRatesDialogInput): MatDialogRef<RentalRatesDialogComponent, RentalRatesDialogResult> {
    return this.dialogService.openLargeSide(RentalRatesDialogComponent, {
      panelClass: ['modal', 'side-modal-lg', 'modal-owner-details', 'modal-rental-rates', 'right'],
      data,
    })
  }
}
